import {useQuery} from "@tanstack/react-query";
import {usersGet} from "../api/users/usersGet.ts";

export const useUsers = () => useQuery({
    queryKey: ['users'],
    queryFn: () => usersGet().then(r => r.payload)
})